import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";
import { QueryGroup } from "@/types/queryBuilder";
import { generateQueryPreview } from "@/utils/queryBuilder";

interface QueryPreviewProps {
	group: QueryGroup;
	count: number;
	isLoading: boolean;
	hasRun: boolean;
}

export function QueryPreview({ group, count, isLoading, hasRun }: QueryPreviewProps) {
	const { t } = useTranslation();
	const preview = generateQueryPreview(group);

	if (!preview)
		return (
			<div className="text-sm text-muted-foreground italic">
				{t("queries.preview.noConditions", "Add conditions to start building your query")}
			</div>
		);

	return (
		<div className="flex items-center gap-3">
			<div className="text-sm font-mono bg-muted px-3 py-2 rounded-sm flex-1 overflow-x-auto">
				{preview}
			</div>
			{hasRun && (
				<Badge variant="secondary" className="shrink-0">
					{isLoading ? (
						<Loader2 className="h-3 w-3 animate-spin mr-1" />
					) : null}
					{t("queries.preview.results", "{{count}} results", { count })}
				</Badge>
			)}
		</div>
	);
}
